import { render, staticRenderFns } from "./TemplateSchemaSettingsCollectionEdit.vue?vue&type=template&id=2f697c52&"
import script from "./TemplateSchemaSettingsCollectionEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateSchemaSettingsCollectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports